@if (loading) {
  <div class="as-fixed-loader">
    <ng-lottie width="150px" height="150px" [options]="options">
    </ng-lottie>
    <mat-label class="as-roboto-slab as-font-bold as-font-20 as-font-red">
      {{ 'GENERAL.loading' | translate }}...
    </mat-label>
  </div>
}
<div class="as-modal-container">
  <p class="as-font as-font-16 as-font-bold as-font-blackish">{{ 'PURCHASE.sure' | translate }}
  {{ data?.type === 'card' ? 'tarjeta' : 'cuenta' }}?</p>
  @if (data?.type === 'account') {
    <div class="payment-method-info">
      <mat-icon class="ic-paypal" svgIcon="ic-paypal">
      </mat-icon>
      <mat-label> {{ data?.paymentMethod?.email }} </mat-label>
    </div>
  }
  @if (data?.type === 'card') {
    <div class="payment-method-info">
      <div class="as-card-brand">
        <mat-icon
          svgIcon="{{data?.paymentMethod?.brand === 'visa' ? 'ic-visa' : data?.paymentMethod?.brand === 'mastercard' ? 'ic-master-c' : data?.paymentMethod?.brand === 'MASTERCARD' ? 'ic-master-c' : data?.paymentMethod?.brand === 'amex' ? 'ic-amex' : data?.paymentMethod?.brand === 'AMEX' ? 'ic-amex' : data?.paymentMethod?.brand === 'VISA' ? 'ic-visa' : ''}}">
        </mat-icon>
        <mat-label> {{ data?.paymentMethod?.brand | titlecase }} </mat-label>
      </div>
      <mat-label class="as-font-grey-88"> **** {{ data?.paymentMethod?.last_digits}} </mat-label>
    </div>
  }
  @if (showCardError) {
    <mat-error>
      <p class="as-font as-font-14">{{ 'PURCHASE.error' | translate }}</p>
    </mat-error>
  }
  <div class="btn-container">
    <button mat-stroked-button color="accent" (click)="closeModal(false)">{{ 'STORES.cancel' | translate }}</button>
    <button mat-flat-button color="accent"
    (click)="data?.type === 'card' ? deleteCard() : deleteAccount()">{{ 'STORES.accept' | translate }}</button>
  </div>
</div>